import { Flex, Skeleton } from "antd";

const RecapActionItemsSkeleton = () => {
  return (
    <Flex className="mt-1" vertical gap={16}>
      {[...Array(6)].map((_, index) => (
        <Skeleton.Input
          className="recap-skeleton"
          key={index}
          active
          size="small"
        />
      ))}
    </Flex>
  );
};

export default RecapActionItemsSkeleton;
